import React, { forwardRef } from "react";
import { QRCodeCanvas } from "qrcode.react";

// Reusable QR preview with optional frame + logo.
// Produces a REAL scannable QR code (qrcode.react).
const QRPreview = forwardRef(function QRPreview(
  { value, fgColor = "#0B1120", bgColor = "#FFFFFF", size = 220, logo, frame = "none", frameText, level = "H" },
  ref
) {
  const frameColor = fgColor;
  const qr = (
    <div className="rounded-xl overflow-hidden" style={{ background: bgColor, padding: 10 }}>
      <QRCodeCanvas
        ref={ref}
        value={value || "https://qromo.app"}
        size={size}
        fgColor={fgColor}
        bgColor={bgColor}
        level={level}
        includeMargin={false}
        imageSettings={
          logo
            ? { src: logo, height: size * 0.22, width: size * 0.22, excavate: true }
            : undefined
        }
      />
    </div>
  );

  if (frame === "none") return qr;

  return (
    <div
      className="inline-flex flex-col items-center"
      style={{
        border: `3px solid ${frameColor}`,
        borderRadius: frame === "rounded" ? 24 : 14,
        padding: 12,
        background: "#fff",
      }}
    >
      {frame === "ticket" && (
        <div
          className="mb-2 px-3 py-1 rounded-full text-[11px] font-bold tracking-wide"
          style={{ background: frameColor, color: bgColor === "#0B1120" ? "#0B1120" : "#fff" }}
        >
          {frameText || "SCOPRI DI PIÙ"}
        </div>
      )}
      {qr}
      {frame !== "ticket" && (
        <div
          className="mt-2 w-full text-center py-1.5 rounded-lg text-[12px] font-extrabold tracking-wider"
          style={{ background: frameColor, color: "#fff" }}
        >
          {frameText || "SCANSIONAMI"}
        </div>
      )}
    </div>
  );
});

export default QRPreview;
